import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { replaceCognitoSession } from "actions/auth";

// Optional: Styling to make sure the banner sits cleanly at the very top
const useStyles = makeStyles((theme) => ({
  bannerAppbar: {
    backgroundColor: theme.palette.warning.dark || '#f57c00',
    color: theme.palette.warning.contrastText || '#fff',
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.drawer + 1,
    padding: theme.spacing(0.5, 2),
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '48px !important', // Compact banner height
  },
  button: {
    color: '#fff',
    borderColor: '#fff',
    marginLeft: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
  },
}));

const ImpersonationBanner = ({ onRestoreSuperAdmin }) => {
  const classes = useStyles();
  const [hasSuperAdminSession, setHasSuperAdminSession] = useState(false);

  const dispatch = useDispatch();

  // Check localStorage on mount and setup storage event listener for cross-tab sync if needed
  useEffect(() => {
    const checkSession = () => {
      const sessionData = window.localStorage.getItem("superAdminSessionData");
      setHasSuperAdminSession(Boolean(sessionData));
    };

    checkSession();

    // Optional: Listen to storage changes if session state changes dynamically across tabs/components
    window.addEventListener('storage', checkSession);
    
    // Custom event dispatcher check if you update localStorage within the same window instance
    window.addEventListener('superAdminSessionChanged', checkSession);

    return () => {
      window.removeEventListener('storage', checkSession);
      window.removeEventListener('superAdminSessionChanged', checkSession);
    };
  }, []);

  const restoreSuperAdminSession = async () => {
    await dispatch(replaceCognitoSession(null, true)); 
    if (onRestoreSuperAdmin) {
      onRestoreSuperAdmin();
    }
  }

  // If no super admin backup session exists, don't render anything
  if (!hasSuperAdminSession) {
    return null;
  }

  return (
    <AppBar position="static" className={classes.bannerAppbar} elevation={2}>
      <Toolbar className={classes.toolbar}>
        <Typography variant="body2" noWrap>
          <strong>Notice:</strong> You are currently logged in as Client view.
        </Typography>
        
        <Button
          variant="outlined"
          size="small"
          className={classes.button}
          onClick={restoreSuperAdminSession} 
        >
          Back to SuperAdmin
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default ImpersonationBanner;